type ContactLike = {
  email?: null | string
  last_name?: null | string
  name?: null | string
  phone?: null | string
  phone_formatted?: null | string
}

type UserLike = null | undefined | { last_name?: null | string; name?: null | string }

export const formatUserName = (user: UserLike, fallback = 'Deleted user'): string => {
  if (!user) return fallback

  const name = user.name?.trim()
  const lastName = user.last_name?.trim()
  const fullName = [name, lastName].filter(Boolean).join(' ')

  return fullName || fallback
}

/** A contact's name, else its email, else its phone: contacts may be saved without a name. */
export const formatContactName = <Fallback>(
  contact: ContactLike | null | undefined,
  fallback: Fallback,
): Fallback | string =>
  formatUserName(contact, '') ||
  contact?.email?.trim() ||
  contact?.phone_formatted?.trim() ||
  contact?.phone?.trim() ||
  fallback
